var _style, _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTb4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000007391755255861556560000011107357605647568276_",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 44,
    height: 44,
    viewBox: "0 0 42 42",
    style: {
      enableBackground: "new 0 0 42 42"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F4EEBA;stroke:#231F20;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st1{fill:#231F20;}\r\n")), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("sfw", {
    xmlns: "&ns_sfw;"
  }, /*#__PURE__*/React.createElement("slices", null), /*#__PURE__*/React.createElement("sliceSourceBounds", {
    bottomLeftOrigin: "true",
    height: 42,
    width: 42,
    x: 0,
    y: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 21,
    cy: 21,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.8,30.4v-2.9h-7.9c-1,0-1.7-0.2-2.2-0.7S12,25.8,12,25c0-0.2,0-0.4,0.1-0.6c0.1-0.2,0.2-0.4,0.3-0.6 c0.2-0.2,0.3-0.5,0.5-0.6c0.2-0.2,0.3-0.5,0.6-0.8l8.3-11.1c0.5-0.7,1-1.2,1.4-1.6c0.3-0.3,0.8-0.5,1.2-0.5c1.6,0,2.4,0.9,2.4,2.7 V24h0.7c0.8,0,1.5,0.1,1.9,0.3S30,25,30,25.8c0,0.6-0.2,1-0.6,1.3c-0.4,0.3-1,0.4-1.8,0.4h-0.9v2.9c0,0.8-0.2,1.4-0.5,1.8 c-0.4,0.4-0.8,0.6-1.4,0.6s-1-0.2-1.4-0.6C22.9,31.8,22.8,31.2,22.8,30.4L22.8,30.4z M16.1,24h6.7v-9.1L16.1,24L16.1,24z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTb4);
export default __webpack_public_path__ + "static/media/Tb4.943f95a046492ba0c9b4452f2944c162.svg";
export { ForwardRef as ReactComponent };